import { render, staticRenderFns } from "./refund-apply.vue?vue&type=template&id=212e2972&scoped=true&"
import script from "./refund-apply.vue?vue&type=script&lang=js&"
export * from "./refund-apply.vue?vue&type=script&lang=js&"
import style0 from "./refund-apply.vue?vue&type=style&index=0&id=212e2972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e2972",
  null
  
)

export default component.exports